import axios from "axios";

export const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const apiConfig = { companyName: null };

export const AxiosClient = axios.create({ baseURL: BASE_URL });

AxiosClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("user");
  if (token) config.headers["x-access-token"] = token;

  const isDD = process.env.REACT_APP_IS_DD === "true";

  if (config.useCompany && apiConfig.target && isDD) {
    if (config.method === "get") {
      config.params = {
        ...config.params,
        company_name: apiConfig.target,
      };
    } else {
      config.data = { ...config.data, company_name: [apiConfig.target] };
    }
  }

  return config;
});
